export default __webpack_public_path__ + "static/media/urban-trash-ita-preview.ba60bf42.pdf";